import { APP_NAME } from '@greenroom/shared'
import { useEffect } from 'react'

/** Sets the tab title, most specific part first: `Weekly show – Studios – Greenroom`. */
export function useTitle(...parts: (string | null | undefined | false)[]) {
  const title = [...parts.filter(Boolean), APP_NAME].join(' – ')
  useEffect(() => {
    document.title = title
  }, [title])
}
